import {RouteDefinition} from '../../../routes';
import {ConciergeListScreen} from './ConciergeListScreen';
import {ConciergeEditScreen} from './ConciergeEditScreen';

export const ConciergeSettingsRoutes: RouteDefinition[] = [
    {
        routerLink: '/settings/concierge',
        component: ConciergeListScreen,
    },
    {
        routerLink: '/settings/concierge/edit/:id',
        component: ConciergeEditScreen,
    },
    {
        routerLink: '/settings/concierge/edit',
        component: ConciergeEditScreen,
    },
];
